import React, { Component } from "react";

export default class JSFunctions extends Component {

    render() {

        return(<div>Placeholder.</div>);

    }
    
}